<app-table
  [compact]="true"
  [columns]="columns"
  [data]="caseList"
  [totalCount]="resultsLength"
  [pageSize]="20"
  [loading]="isLoadingResults"
  (searchChange)="onSearch($event)"
  [clickableRows]="true"
  (rowClick)="gotoCase($event)">

  <ng-template tableCell="instructedDate" let-row>
    {{ row.instructedDate | date:'dd-MM-yyyy' }}
  </ng-template>

  <ng-template tableCell="caseCompletionPercentage" let-row>
    {{ row.caseCompletionPercentage != null ? (row.caseCompletionPercentage + '%') : '-' }}
  </ng-template>

  <ng-template tableCell="caseTierSeverityType" let-row>
  <span *ngIf="row.caseTierSeverityType === 1" 
        style="display: inline-block; width: 36px; height: 16px; border-radius: 3px; background-color: var(--bs-success);">
  </span>
  <span *ngIf="row.caseTierSeverityType === 2"
        style="display: inline-block; width: 36px; height: 16px; border-radius: 3px; background-color: var(--bs-warning);">
  </span>
  <span *ngIf="row.caseTierSeverityType === 3"
        style="display: inline-block; width: 36px; height: 16px; border-radius: 3px; background-color: var(--bs-danger);">
  </span>
</ng-template>

</app-table>